import React from 'react'

export const ListCheck = ({ className,state="default" }) => {
  return (
    <svg
      className={`${className}`}
      fill="none"
      height="24"
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11 18H3M15 18L17 20L21 16M16 12H3M16 6H3"
        stroke={state=="active"?"white":"black"}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </svg>
  );
};